module.exports = __webpack_public_path__ + "static/media/sdg_icon_15.3d11c141.png";